import React, { useEffect, useState } from "react";
import "./product.scss";
import snackbarStore from "../../stores/snackbarStore";
import productStore from "../../stores/productStore";
import SnackbarAlert from "../../components/snackbarAlert/snackbarAlert";
import TwoBreadcrumb from "../../components/breadcrumbs/TwoBreadcrumb";
import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputAdornment,
  InputLabel,
  LinearProgress,
  TextField,
  Tooltip,
} from "@mui/material";
import { Link } from "react-router-dom";
import { IoIosAdd } from "react-icons/io";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import categoryStore from "../../stores/categoryStore";
import CustomNoRowsOverlay from "../../components/customNoRowsOverlay/CustomNoRowsOverlay";
import useMediaQuery from "@mui/material/useMediaQuery";
import dateFormat from "dateformat";

// Icons
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { PRODUCT_IMAGE_URL } from "../../constant";
import sidebarActivePage from "../../stores/sidebarActivePage";
import ProductFilter from "./productFilter/ProductFilter";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import SearchIcon from "@mui/icons-material/Search";

const Product = () => {
  const SnackbarStore = snackbarStore();
  const ProductStore = productStore();
  const CategoryStore = categoryStore();
  const SidebarActivePage = sidebarActivePage();
  const matches = useMediaQuery("(min-width:1100px)");

  const [rows, setRows] = useState(null);
  const [categoryID, setCategoryID] = useState("");
  const [productName, setProductName] = useState("");
  const [staringCreateAtDate, setStaringCreateAtDate] = useState(null);
  const [endingCreateAtDate, setEndingCreateAtDate] = useState(null);
  const [staringUpdateAtDate, setStaringUpdateAtDate] = useState(null);
  const [endingUpdateAtDate, setEndingUpdateAtDate] = useState(null);
  const [staringPrice, setStaringPrice] = useState("");
  const [endingPrice, setEndingPrice] = useState("");
  const [publish, setPublish] = useState("");

  useEffect(() => {
    SidebarActivePage.setIsActive({ setPage: "Product" });
    ProductStore.clearProductForm();
    ProductStore.clearProductID();
    init();
  }, []);

  const columns = [
    // { field: "_id", headerName: "ID", flex: 1 },
    {
      field: "productName",
      headerName: "Product",
      width: !matches && 350,
      flex: matches && 2,
      filterable: false,
      renderCell: (params) => (
        <Grid container>
          <Grid
            item
            xs={matches ? 2.5 : 3}
            sx={{
              p: 1,
              display: "flex",
              alignContent: "center",
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={`${PRODUCT_IMAGE_URL}${params.row.productImages[0]}`}
              width="90%"
              height="55px"
              sx={{ objectFit: "cover", borderRadius: "5px" }}
            />
          </Grid>
          <Grid
            item
            xs={matches ? 9.5 : 9}
            sx={{
              display: "flex",
              alignItems: "flex-start",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <h3>{params.row.productName}</h3>
            <p>
              {CategoryStore.category.map(
                (item) =>
                  item._id === params.row.categoryID && item.categoryName
              )}
            </p>
          </Grid>
        </Grid>
      ),
    },
    {
      field: "created_at",
      headerName: "Create at",
      width: !matches && 150,
      flex: matches && 1,
      filterable: false,
      renderCell: (params) => {
        const pDate = params.row.created_at;
        const date = dateFormat(new Date(pDate), "dd mmm yyyy");
        const time = new Date(pDate).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
        return (
          <div>
            <h4 style={{ fontWeight: 600 }}>{date}</h4>
            <p>{time}</p>
          </div>
        );
      },
    },
    {
      field: "updated_at",
      headerName: "Update at",
      width: !matches && 150,
      flex: matches && 1,
      filterable: false,
      renderCell: (params) => {
        const pDate = params.row.updated_at;
        const date = dateFormat(new Date(pDate), "dd mmm yyyy");
        const time = new Date(pDate).toLocaleString("en-US", {
          hour: "numeric",
          minute: "numeric",
          hour12: true,
        });
        return (
          <div>
            <h4 style={{ fontWeight: 600 }}>{date}</h4>
            <p>{time}</p>
          </div>
        );
      },
    },
    {
      field: "regularPrice",
      headerName: "Price",
      width: !matches && 120,
      filterable: false,
      flex: matches && 0.7,
      renderCell: (params) => `₹ ${params.row.regularPrice}`,
    },
    {
      field: "publish",
      headerName: "Publish",
      width: !matches && 120,
      flex: matches && 0.6,
      renderCell: (params) =>
        params.row.publish ? (
          <Box
            sx={{
              background: "var(--babyBlue)",
              p: "2px 5px",
              borderRadius: "5px",
            }}
          >
            <h4 color="var(--blueColor)">Published</h4>
          </Box>
        ) : (
          <Box
            sx={{
              background: "var(--bgColor)",
              p: "2px 5px",
              borderRadius: "5px",
            }}
          >
            <h4 style={{ color: "var(--textColor)" }}>Draft</h4>
          </Box>
        ),
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      filterable: false,
      hideable: false,
      width: !matches && 120,
      flex: matches && 0.6,
      renderCell: (params) => {
        const options = [
          { name: "Edit", icon: <EditIcon />, to: "/product" },
          { name: "View", icon: <VisibilityIcon />, to: "/product/details" },
        ];

        return (
          <div
            style={{
              display: "flex",
              flex: 1,
              justifyContent: "space-around",
            }}
          >
            {options.map((item) => (
              <Tooltip key={item.name} title={item.name}>
                <Link to={`${item.to}/${params.row._id}`}>{item.icon}</Link>
              </Tooltip>
            ))}
          </div>
        );
      },
    },
  ];

  const init = async () => {
    if (SnackbarStore.massage !== "") {
      SnackbarStore.setIsOpen({ value: true });
    }
  };

  useEffect(() => {
    if (ProductStore.product) {
      let filterData = ProductStore.product;

      if (productName !== "") {
        const productNameFilter = filterData.filter((item) => {
          return item.productName
            .toLowerCase()
            .includes(productName.toLowerCase());
        });
        filterData = productNameFilter;
      }

      if (ProductStore.productFilterApply !== 0) {
        if (categoryID !== "") {
          const categoryIDFilter = filterData.filter((item) => {
            if (item.categoryID === categoryID) {
              return item;
            }
          });
          filterData = categoryIDFilter;
        }

        if (publish !== "") {
          const publishFilter = filterData.filter((item) => {
            if (item.publish === publish) {
              return item;
            }
          });
          filterData = publishFilter;
        }

        if (staringCreateAtDate !== null && endingCreateAtDate !== null) {
          const dateFilter = filterData.filter((item) => {
            const created_at = new Date(item.created_at);
            const endDate = new Date(endingCreateAtDate);
            endDate.setDate(endDate.getDate() + 1);
            if (
              new Date(staringCreateAtDate) <= created_at &&
              created_at <= endDate
            ) {
              return item;
            }
          });
          filterData = dateFilter;
        }

        if (staringUpdateAtDate !== null && endingUpdateAtDate !== null) {
          const dateFilter = filterData.filter((item) => {
            const updated_at = new Date(item.updated_at);
            const endDate = new Date(endingUpdateAtDate);
            endDate.setDate(endDate.getDate() + 1);
            if (
              new Date(staringUpdateAtDate) <= updated_at &&
              updated_at <= endDate
            ) {
              return item;
            }
          });
          filterData = dateFilter;
        }

        if (staringPrice !== "" && endingPrice !== "") {
          const priceFilter = filterData.filter((item) => {
            if (
              staringPrice <= item.regularPrice &&
              item.regularPrice <= endingPrice
            ) {
              return item;
            }
          });
          filterData = priceFilter;
        }
      }
      setRows(filterData);
    }
  }, [ProductStore.product, productName, ProductStore.productFilterApply]);

  return (
    <div className="product">
      <SnackbarAlert
        isOpen={SnackbarStore.isOpen}
        alertVariant="filled"
        onClose={() => {
          SnackbarStore.setIsOpen({ value: false });
          SnackbarStore.setMassage({ value: "" });
        }}
        massage={SnackbarStore.massage}
      />
      <div className="heading">Product</div>
      <TwoBreadcrumb mainName="Product" mainLink="product" activeName="List" />
      <div className="btn-right-side flex">
        <Link to="/product/new">
          <Button variant="contained" className="btn" startIcon={<IoIosAdd />}>
            New Product
          </Button>
        </Link>
      </div>
      <div className="product-filter-container">
        <FormControl variant="standard">
          <InputLabel htmlFor="standard-adornment-search" value={productName}>
            <p style={{ fontWeight: 500 }}>Search Product Name</p>
          </InputLabel>
          <Input
            id="standard-adornment-search"
            name="productName"
            value={productName}
            onChange={(e) => {
              const { value } = e.target;
              setProductName(value);
            }}
            endAdornment={
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </FormControl>
        <ProductFilter
          categoryID={categoryID}
          setCategoryID={setCategoryID}
          staringCreateAtDate={staringCreateAtDate}
          setStaringCreateAtDate={setStaringCreateAtDate}
          endingCreateAtDate={endingCreateAtDate}
          setEndingCreateAtDate={setEndingCreateAtDate}
          staringUpdateAtDate={staringUpdateAtDate}
          setStaringUpdateAtDate={setStaringUpdateAtDate}
          endingUpdateAtDate={endingUpdateAtDate}
          setEndingUpdateAtDate={setEndingUpdateAtDate}
          staringPrice={staringPrice}
          setStaringPrice={setStaringPrice}
          endingPrice={endingPrice}
          setEndingPrice={setEndingPrice}
          publish={publish}
          setPublish={setPublish}
        />
      </div>
      <Grid
        container
        sx={{
          mt: 3,
          background: "var(--whiteColor)",
          borderRadius: "5px",
          boxShadow: "0 2px 4px var(--grayText)",
        }}
      >
        <DataGrid
          autoHeight
          getRowId={(row) => row._id}
          rows={rows ? rows.slice(0).reverse() : []}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 5 },
            },
          }}
          loading={rows ? false : true}
          density="comfortable"
          slots={{
            // toolbar: GridToolbar,
            loadingOverlay: LinearProgress,
            noRowsOverlay: CustomNoRowsOverlay,
          }}
          pageSizeOptions={[5, 10]}
          // checkboxSelection
        />
      </Grid>
    </div>
  );
};

export default Product;
